export default {
	"ShareModal.ShareTips": "分享提示",
	"ShareModal.ShareWithFriends": "分享給好友",
	"ShareModal.ClickTheOneInTheTopRightCorner": "點擊右上角的",
	"ShareModal.buttonToShare": "按鈕分享。",
	"ShareModal.GenerateAPoster": "生成海報",
	"ShareModal.ClickTheGeneratePosterButtonToSaveThePosterImage": "點擊生成海報按鈕，進行海報圖片保存。"
}